/**
 * Project : workspace
 * File    : TextLink.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component.text

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import theme.ThemeColor

@Composable
/**
 * Executes the text link operation.
 *
 * @receiver TODO
 * @param title The title.
 * @param onClick The on click.
 * @return Unit – no return value.
 */
fun TextLink(title: String = "Title", onClick: () -> Unit = {}) {
    Text(
        title,
        fontSize = 16.sp,
        fontStyle = FontStyle.Normal,
        fontWeight = FontWeight.Medium,
        textAlign = TextAlign.Center,
        textDecoration = TextDecoration.Underline,
        color = ThemeColor.shared().LightBlue,
        modifier = Modifier.padding(start = 8.dp).clickable { onClick() }
    )
}